import React, { useCallback } from 'react';

import { Alert, Box } from '@mui/material';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';

import { useAccommodationServiceFetch } from '~/components/Accommodation/hooks/useAccommodationServiceFetch';

import ReservationService from '~/services/ReservationService';

interface Property {
  id: string;
  name: string;
  id_salesforce_external: string;
  chain_id: string;
  geo_country_code: string;
}

interface Props {
  chainId: string;
}

export default function ChainVendorsTab({ chainId }: Props) {
  const fetchProperties = useCallback(() => ReservationService.getChainProperties(chainId), [chainId]);

  const { fetchReqState } = useAccommodationServiceFetch<Property[]>({
    fetchFn: fetchProperties,
  });

  const columns: Array<GridColDef<Property>> = [
    {
      field: 'name',
      headerName: 'Property Name',
      flex: 2,
      display: 'flex',
      minWidth: 200,
    },
    {
      field: 'id_salesforce_external',
      headerName: 'Salesforce ID',
      flex: 1.5,
      display: 'flex',
      minWidth: 180,
      renderCell: (params) => (
        <span style={{ fontFamily: 'monospace', fontSize: 13, color: 'rgba(0,0,0,0.54)' }}>{params.value}</span>
      ),
    },
    {
      field: 'geo_country_code',
      headerName: 'Country',
      width: 100,
      display: 'flex',
    },
  ];

  const properties = fetchReqState.status === 'succeeded' ? fetchReqState.result || [] : [];

  return (
    <>
      {fetchReqState.status === 'failed' && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Failed to load properties
        </Alert>
      )}
      <Box sx={{ width: '100%' }}>
        <DataGrid
          columns={columns}
          rows={properties}
          loading={fetchReqState.status === 'pending'}
          autoHeight
          pageSizeOptions={[25, 50]}
          initialState={{
            pagination: { paginationModel: { pageSize: 25 } },
          }}
          slots={{ toolbar: GridToolbar }}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          disableColumnFilter
          disableDensitySelector
        />
      </Box>
    </>
  );
}
